import { CountryService } from "src/app/shared/services/country.service";
import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from "@angular/core";
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Helper } from "src/app/core/helpers/helper";
import { AdminService } from "../../services/admin.service";

@Component({
  selector: "app-country-phonecode",
  templateUrl: "./country-phonecode.component.html",
  styleUrl: "./country-phonecode.component.scss",
  standalone: false
})
export class CountryPhonecodeComponent {
  modalRef!: NgbModalRef;
  modalConfig: NgbModalOptions = { size: "sm", centered: true, backdrop: "static" };

  countryArray: Array<any> = [];
  selectedCountry: any;

  searchText: string = "";

  /** When true, pulls the unfiltered /api/country/all list (mirrors user-panel). */
  @Input() useFullList: boolean = false;
  /** When false, skips the auto-emit that selects the first country on init. */
  @Input() isSelectDefault: boolean = true;

  @Output() countryChange = new EventEmitter();
  @ViewChild("template", { static: true }) template!: TemplateRef<any>;

  constructor(private modalService: NgbModal, private countryService: CountryService, private helper: Helper, private adminService: AdminService) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.getCountryList();
    }, 200);
  }

  /**
   * Opens the country list modal using the modal service and specified template and configuration.
   * @returns {void}
   */
  showModal(): void {
    this.modalRef = this.modalService.open(this.template, this.modalConfig);
  }

  /**
   * Retrieves the list of countries from the server and populates the countryArray.
   * @returns {void}
   */
  getCountryList(): void {
    const parameters: any = {};
    const source$ = this.useFullList
      ? this.countryService.getAllCountryList(parameters)
      : this.countryService.getCountryList(parameters);

    source$.subscribe((response: any) => {
      this.countryArray = response?.countries || [];
      if (this.countryArray.length && this.isSelectDefault) {
        const first = this.countryArray[0];
        this.countrySelect(first.phoneCodes[0], first.code2 ?? first.alpha2);
      }
    });
  }

  /**
   * Handles the country selection event, emits country change event, and closes the modal.
   * @param {any} phoneCode - The phone code of the selected country.
   * @param {string} countryCode - The code of the selected country.
   * @returns {void}
   */
  countrySelect(phoneCode: any, countryCode: string): void {
    this.adminService.getDetails({ isShowSuccessToast: false, countryCode }).subscribe((response: any) => {
      this.helper.getCorporateDetail.next(response);
      this.helper.minPhoneNumberLength = response.setting.minPhoneLength;
      this.helper.maxPhoneNumberLength = response.setting.maxPhoneLength;
      this.helper.secOtpResendInterval = response.setting.entitySetting.secOtpResendInterval;
      this.selectedCountry = phoneCode;
      this.countryChange.emit(phoneCode);
    });
    this.closeModal();
  }

  /**
   * Closes the country list modal if it's open.
   * @returns {void}
   */
  closeModal(): void {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }
}
